export const URLImages = "https://image.tmdb.org/t/p/";
export const posterURL = `${URLImages}w300_and_h450_bestv2`;
export const backdropURL = `${URLImages}w1920_and_h800_multi_faces`;
export const genresURL =
  "https://api.themoviedb.org/3/genre/movie/list?api_key=741487ab9378f09398cb15784041196d&language=en-US";
